import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import PostalMime from 'postal-mime';
import { from, Observable, of, switchMap } from 'rxjs';
import { HelpersService } from 'src/app/core/services/helpers.service';

@Injectable({
  providedIn: 'root'
})
export class EmlPreviewResolver implements Resolve<boolean> {
  constructor(private helpers: HelpersService) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let idDocument = route.paramMap.get('idDocumento')!;
    let refDocumentale = route.paramMap.get('refDocumentale')!;
    if(!!refDocumentale) {
      return this.emlPreviewRefDocumentale(refDocumentale);

    }
    if(idDocument === "buffer") {
      return of(true);
    }
    return this.emlPreview(idDocument)
  }

  private emlPreviewRefDocumentale(refDocumentale: string) {
    return this.helpers.showPreviewWithRefDocumentale(refDocumentale).pipe(
      switchMap(res => {
        if (!!res) {
          return from(
            PostalMime.parse(res.body, { attachmentEncoding: "base64" })
          );
        } else {
          return of(false);
        }
      })
    );
  }

  

  private emlPreview(idDocument: string): Observable<any> {
    return this.helpers.getPreview(idDocument).pipe(
      switchMap(res => {
        if (!!res) {
          return from(
            PostalMime.parse(res.body, { attachmentEncoding: "base64" })
          );
        } else {
          return of(false);
        }
      })
    );
  }
}
